export const AMC_CATEGORY_LIST_AMC_DATA = "AMC_CATEGORY_LIST_AMC_DATA";
export const AMC_CATEGORY_LIST_AMC_ERROR = "AMC_CATEGORY_LIST_AMC_ERROR";
export const AMC_CATEGORY_LIST_AMC_HIDE_ERROR = "AMC_CATEGORY_LIST_AMC_HIDE_ERROR";
export const AMC_CATEGORY_LIST_AMC_START_LOADER = "AMC_CATEGORY_LIST_AMC_START_LOADER";
export const AMC_CATEGORY_LIST_AMC_STOP_LOADER = "AMC_CATEGORY_LIST_AMC_STOP_LOADER";
